__turbopack_context__.v({
  "homeEditableTitleBox": "home-editable-module__0H1jIa__homeEditableTitleBox",
  "homeEditableTitlePositioner": "home-editable-module__0H1jIa__homeEditableTitlePositioner",
  "homeTileEditableTitleBox": "home-editable-module__0H1jIa__homeTileEditableTitleBox",
  "homeTileEditableTitlePositioner": "home-editable-module__0H1jIa__homeTileEditableTitlePositioner",
});
